/**
 * Normalize list-shaped API responses so UI .map() never runs on objects.
 */

export function asArray(value) {
  return Array.isArray(value) ? value : []
}

/** Flatten GET /api/alerts/list — plain array or group_by_cluster payload. */
export function normalizeAlertsListResponse(json) {
  if (!json || json.success === false) return []
  if (Array.isArray(json.data)) return json.data
  if (json.grouped) {
    const clusters = asArray(json.data)
    const fromClusters = clusters.flatMap((c) => asArray(c?.alerts))
    return [...fromClusters, ...asArray(json.unclustered)]
  }
  return []
}

const EMPTY_ANALYTICS_OVERVIEW = {
  totalAlerts: 0,
  alertsToday: 0,
  alertsTrend: 0,
  activeRules: 0,
  rulesTrend: 0,
  avgResponseTime: 0,
  responseTrend: 0,
  falsePositiveRate: 0,
  fpTrend: 0,
}

const EMPTY_ANALYTICS = {
  overview: { ...EMPTY_ANALYTICS_OVERVIEW },
  alertsByCategory: [],
  alertsBySeverity: [],
  alertsByType: [],
  timeSeriesData: [],
  topRules: [],
  performanceMetrics: {},
}

export function normalizeAnalyticsDashboardData(raw) {
  if (!raw || typeof raw !== 'object') return { ...EMPTY_ANALYTICS }
  return {
    overview: {
      ...EMPTY_ANALYTICS_OVERVIEW,
      ...(raw.overview && typeof raw.overview === 'object' ? raw.overview : {}),
    },
    alertsByCategory: asArray(raw.alertsByCategory),
    alertsBySeverity: asArray(raw.alertsBySeverity),
    alertsByType: asArray(raw.alertsByType),
    timeSeriesData: asArray(raw.timeSeriesData),
    topRules: asArray(raw.topRules),
    performanceMetrics:
      raw.performanceMetrics && typeof raw.performanceMetrics === 'object'
        ? raw.performanceMetrics
        : {},
  }
}
